export default __webpack_public_path__ + "static/carousel-homepage-1-82aff5e185dd166a091dcb46bba1152a.jpg";